<template>
    <xx-select
        :value="value"
        :list="list"
        :value-key="valueKey"
        @input="input"
        @change="change"
        v-bind="$attrs"
        v-on="listeners"
    ></xx-select>
</template>

<script>
import { isEqual, cloneDeep } from '@lsfe/tools'
import XxSelect from './index.vue';

export default {
    name: 'XxSupplierSelect',
    props: {
        value: {
            required: false
        },
        responseFilter: {
            type: Function,
            default: res => {
                return res;
            }
        },
        status: {
            type: [Number, String]
        },
        poiId: [String, Number],
        valueKey: {
            type: String,
            default: 'value'
        },
        needAuth: {
            type: Boolean,
            default: false
        },
        // 这里修改参数都会重新调用接口
        extraParams: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        XxSelect
    },
    data() {
        return {
            list: []
        };
    },
    computed: {
        listeners() {
            const { change, ...listeners } = this.$listeners;
            return listeners;
        },
        // 为了检测extraParams变化
        extraParamsCom() {
            return cloneDeep(this.extraParams);

        }
    },
    watch: {
        poiId() {
            this.fetchData();
        },
        extraParamsCom: {
            deep: true,
            handler(newValue, oldValue) {
                if (!isEqual(newValue, oldValue)) {
                    this.fetchData()
                }
            }
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        input(val) {
            this.$emit('input', val);
        },
        change(val, item) {
            this.$emit('change', val, item);
        },
        fetchData() {
            this.$nextTick(() => {
                let api = '/api/m/sqm/supplier/main/info/getsimplesupplierinfo';
                let params = { needAuth: this.needAuth ? 1 : 0, supplierStatus: this.status };
                let type = '$hPost';
                if (this.poiId) {
                    api = '/api/m/sqm/supplier/main/info/mappoiorskuandsuppliersimpleinfolist';
                    params = { poiId: this.poiId };
                    type = '$hGet';
                }
                const requestParams = { ...params, ...this.extraParams };
                return this[type](api, requestParams, { cached: true }).then(res => {
                    let ret = (res || []).map(item => {
                        return Object.assign({}, item, {
                            label: `${item.name}(${item.code})`,
                            value: `${item.id}`
                        });
                    });
                    this.list = this.responseFilter(ret);
                });
            });
        }
    }
};
</script>
